import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { TableBodyProps, TableComponents, TableProps } from 'react-virtuoso';
import { VirtualizedTableTestIds } from '../../../../utils/testIds/VirtualizedTable.testIds';
import { BaseItem, InternalData, VirtualizedTableContext } from './VirtualizedTable.types';
import TableScroller from './scroller/TableScroller';
import { useStyles } from './virtualizedTable.styles';
import { VIRTUALIZED_TABLE_ID } from './virtualizedTableIds';

const INERT_ROW = { inert: '' };

export const components: TableComponents = {
  Table: (props: TableProps) => {
    const { classes } = useStyles();
    return <Table {...props} className={classes.table} id={VIRTUALIZED_TABLE_ID} />;
  },
  Scroller: TableScroller,
  TableHead: forwardRef((props, ref) => {
    return (
      <TableHead {...props} ref={ref}>
        {props.children}
      </TableHead>
    );
  }),
  TableRow: (props) => {
    const item = props.item as InternalData<BaseItem>;
    const context = props.context as VirtualizedTableContext | undefined;
    const isBanded = !!item && !!context?.bandedRowIds.has(item.id);

    const { classes } = useStyles();
    const className = classNames({
      [classes.tableRowHover]: true,
      [classes.selectedRow]: item?.isSelected,
      [classes.parentRow]: item?.isParent,
      [classes.rootParentRow]: item?.isParent && !item?.isChild,
      [classes.disablePointerCursor]: item?.disablePointerCursor,
    });

    return (
      <TableRow
        {...props}
        {...(isBanded && INERT_ROW)}
        className={className}
        data-row-id={item?.id}
        test-id={`${VirtualizedTableTestIds.ROW_PREFIX}${item?.id}`}
      />
    );
  },
  TableBody: forwardRef<HTMLTableSectionElement, TableBodyProps>((props, ref) => (
    <TableBody {...props} ref={ref} />
  )),
};
